import { AccreditationForm } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export default {
  component: () => AccreditationForm,
  mapEntryToProps: (entry: PLAYER_PORTALS_MODELS.AccreditationForm) =>
    kontentAiDataMapping.accreditation_form(entry),
  depthParameter: 5,
};
